import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noFutureYearValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const enteredYear = Number(control.value);
  const currentYear = new Date().getFullYear();

  if (enteredYear > currentYear) {
    return { futureYear: true };
  }

  return null;
}
